import { InjectionToken } from '@angular/core';

export const DIALOG_DATA = new InjectionToken<unknown>('DIALOG_DATA');
